

// MUI base styles
import borders from "../base/borders";

const { borderRadius } = borders;

const avatar:any = {
  styleOverrides: {
    root: {
      transition: "all 200ms ease-in-out",
    },

    rounded: {
      borderRadius: borderRadius.lg,
    },

    img: {
      height: "auto",
    },
  },
};

export default avatar;
